<template>
  <div>
    <section style="margin-right: 20px; margin-top: 10px">
      <div class="box box-danger">
        <div class="box-body">
          <div v-if="this.isError" class="text-danger">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            Error occurred while loading the data.
          </div>

          <app-no-data
            v-if="
              !this.isError &&
              (this.actData == null || this.actData.length == 0)
            "
          ></app-no-data>
          <div
            v-show="
              !this.isError && this.actData != null && this.actData.length > 0
            "
          >
            <table :id="tableId" class="table table-bordered table-striped" />
          </div>
        </div>
        <div v-if="this.isLoading" class="overlay">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
      </div>

      <div class="modal modal-danger fade" id="modal-danger" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" style="background-color: #dd4b39; color: #fff; border-radius: 3px 3px 0 0">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                style="color: #fff; opacity: 0.8"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                <i class="fa fa-trash" style="margin-right: 8px"></i>Delete Activation Code
              </h4>
            </div>
            <div class="modal-body" style="padding: 20px 24px">
              <p style="margin: 0 0 10px; font-size: 14px; color: #555">
                Are you sure you want to delete this activation code? This action cannot be undone.
              </p>
              <div v-if="selectedRowData" style="background: #f9f2f4; border: 1px solid #e8d5d5; border-radius: 4px; padding: 10px 14px; font-family: monospace; font-size: 13px; color: #c7254e; word-break: break-all">
                {{ selectedRowData.activationCode }}
              </div>
              <div v-if="selectedRowData && selectedRowData.partyName" style="margin-top: 10px; font-size: 13px; color: #777">
                <i class="fa fa-user" style="margin-right: 5px"></i>{{ selectedRowData.partyName }}
              </div>
            </div>
            <div class="modal-footer" style="padding: 12px 16px">
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                @click="cancel()"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="deactivate()"
              >
                <i class="fa fa-trash" style="margin-right: 5px"></i>Yes, Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ActivationFilter from "./ActivationFilter";

export default {
  data() {
    return {
      dialog: false,
      tableRef: null,
      tableId:
        "ID" + Math.floor(Math.random() * (1000 - 1 + 1)) + 1 + Date.now(),
      tableColumns: [
        {
          data: "activationCode",
          title: "Activation Code",
          type: "string",
          render: function (data, type, row) {
            return '<div style="color:green;">' + data + "</div>";
          },
        },
        {
          data: "purchaseDate",
          title: "Purchase Date",
          type: "date",
          render: function (data, type, row) {
            return new Date(data).toLocaleDateString("en-US");
          },
        },
        {
          data: "period",
          title: "Period",
          type: "number",
          render: null,
        },
        {
          data: "partyName",
          title: "Party Name",
          type: "string",
          render: this.partyRender,
          orderData: [4],
        },
        {
          data: "partyName",
          title: "Party Name",
          type: "string",
          render: null,
          visible: false,
        },
        {
          data: "partnerId",
          title: "Partner",
          type: "string",
          render: null,
          visible: false,
        },
        {
          data: "partyEmail",
          title: "Party Email",
          type: "string",
          render: null,
          visible: false,
        },
        {
          data: "transactionType",
          title: "Transaction Type",
          type: "string",
          render: null,
          visible: false,
        },
        {
          data: null,
          title: "Delete",
          render: function (data, type, row) {
            return (
              '<div><button data-toggle="modal" data-target="#modal-danger" class="btn btn-danger btn-xs">' +
              '  <i class="fa fa-trash"></i></button></div>'
            );
          },
          orderable: false,
        },
      ],
      selectedCode: null,
      selectedRowData: null,
    };
  },
  components: {
    appFilter: ActivationFilter,
  },
  computed: {
    ...mapGetters("activation", ["isError", "isLoading", "actData"]),
  },
  mounted() {
    if (this.tableRef != null) this.tableRef.destroy();
    this.buildTable();
  },
  watch: {
    actData: {
      handler: function (val, oldVal) {
        if (val != null) {
          // console.log("actData changed: ", val.length);
          if (this.tableRef != null) this.tableRef.destroy();
          this.buildTable();
        }
      },
      deep: true,
    },
  },
  methods: {
    // ...mapActions({
    //   stateSubSetPartyEmail: sub_types.SUB_ACTION_FILTER_EMAIL,
    //   deleteCodeById: types.ACT_ACTION_DELETE_CODE,
    //   refreshData: types.ACT_ACTION_REFRESH,
    // }),
    partyRender(data, type, row) {
      if (!data) return "";

      let partyPartner =
        '<span class="pull-right"><img height="20px" src="/src/assets/img/' +
        row.partnerId +
        '-logo.png"></span>';

      // partyPartner += '<span style="margin-right: 5px" class="label pull-right bg-aqua">' + row.partyType + '</span>';

      let transType = "";
      if (row.transactionType)
        transType +=
          '<span style="margin-right: 5px" class="label pull-right bg-yellow">' +
          row.transactionType +
          "</span>";

      let col =
        partyPartner +
        transType +
        '<span class="text-fuchsia">' +
        data +
        "</span>";

      if (row.partyEmail)
        col +=
          '<div><a style="cursor: pointer" class="text-blue text-sm">' +
          row.partyEmail +
          "</a></div>";

      return col;
    },
    navigateToActivationCodes(data) {
      this.stateSubSetPartyEmail(data.partyEmail);
      this.$router.push("/subscription?submit=true");
    },
    buildTable() {
      this.tableRef = $("#" + this.tableId).DataTable({
        deferRender: true,
        aaData: this.actData,
        aoColumns: this.tableColumns,
        paging: true,
        lengthChange: true,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,
        dom: '<"top"Bt><"bottom"<"row"<"col-md-6 ln1"il><"col-md-6 pull-right"p>>>',
        oLanguage: { sSearch: '<i class="fa fa-search text-primary"></i>' },
        buttons: [
          {
            extend: "excel",
            text: '<i class="fa fa-file-excel-o"></i> Excel',
            className: "btn btn-success btn-xs",
            exportOptions: {
              columns: [0, 1, 2, 4, 5, 6, 7],
            },
          },
          {
            extend: "pdf",
            exportOptions: {
              columns: [0, 1, 2, 4, 5, 6, 7],
            },
            text: '<i class="fa fa-file-pdf-o"></i> PDF',
            className: "btn bg-primary btn-xs",
          },
          {
            extend: "print",
            exportOptions: {
              columns: [0, 1, 2, 4, 5, 6, 7],
            },
            text: '<i class="fa fa-print"></i> Print',
            className: "btn btn-warning btn-xs",
          },
          {
            extend: "copy",
            exportOptions: {
              columns: [0, 1, 2, 4, 5, 6, 7],
            },
            text: '<i class="fa fa-copy"></i> Copy',
            className: "btn btn-danger btn-xs",
          },
        ],
      });

      $("div.dataTables_filter input").css({
        display: "inline-block",
        border: "1px solid #3b8ab8",
        padding: "5px",
      });
      $("div.dataTables_filter input").attr("placeholder", "Quick search...");

      let table = this.tableRef;
      let vueObj = this;
      $("#" + this.tableId + " tbody").off("click");
      $("#" + this.tableId + " tbody").on("click", "tr", function () {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        } else {
          table.$("tr.selected").removeClass("selected");
          $(this).addClass("selected");
        }
      });
      $("#" + this.tableId + " tbody").on("click", "a", function () {
        var data = table.row($(this).parents("tr")).data();
        vueObj.navigateToActivationCodes(data);
      });
      $("#" + this.tableId + " tbody").on("click", "button", function () {
        var data = table.row($(this).parents("tr")).data();
        vueObj.selectedCode = data.activationCodeId;
        vueObj.selectedRowData = data;
      });
    },
    deactivate() {
      if (this.selectedCode != null) {
        this.$store.dispatch("activation/delete", this.selectedCode).then(
          () => {
            this.$store.dispatch("activation/refresh");
            this.selectedCode = null;
            this.selectedRowData = null;
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
    cancel() {
      this.selectedCode = null;
      this.selectedRowData = null;
    },
  },
};
</script>

<style scoped>
.deactivate-modal .modal {
  position: relative;
  top: auto;
  bottom: auto;
  right: auto;
  left: auto;
  display: block;
  z-index: 1;
}

.deactivate-modal .modal {
  background: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/paywall/activation/ActivationResult.vue